module.exports = __webpack_public_path__ + "static/media/delete.51cdc80f.svg";